<!-- 员工管理 -->
<template>
    <div class="business-content-main">
        <breadcrumb></breadcrumb>
        <el-container style="height: 700px">
            <el-header style="line-height: 60px; padding: 0 20px 0 0">
                <el-button class="btn-primary" icon="el-icon-printer" size="small" v-if="permission.printstaffCode" @click="printLabels()">{{
                    permission.printstaffCode
                }}</el-button>
                <el-button class="btn-primary" icon="el-icon-document" size="small" v-if="permission.randprecord" @click="gotoStaffRecord()">{{
                    permission.randprecord
                }}</el-button>
                <el-button class="btn-primary" style="margin-right: 10px" icon="el-icon-plus" size="small" @click="showDialog(4)">添加员工</el-button>
                <el-button class="btn-primary btn-warning" v-if="permission.clearToken" style="margin-right: 10px" size="small" @click="openClearTokenDialog()">{{
                    permission.clearToken
                }}</el-button>
                <el-checkbox v-model="searchData.notLeave" @change="onNotLeaveChecked">过滤离职员工</el-checkbox>
            </el-header>
            <el-container style="height: 100%">
                <el-aside :width="isShrink ? '0' : '15%'" height="100%" style="transition: all 0.3s">
                    <el-card class="box-card" style="padding: 10px; height: 100%; overflow: auto">
                        <el-row>
                            <el-col :span="24">
                                <el-input size="small" placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                            </el-col>
                        </el-row>
                        <el-tree
                            check-strictly
                            highlight-current
                            default-expand-all
                            :data="staffData"
                            ref="treeOrg"
                            :filter-node-method="filterNode"
                            node-key="Id"
                            :props="treeProps"
                            @node-click="handleNodeClick"
                        >
                            <span class="custom-tree-node" slot-scope="{ node, data }">
                                <span>{{ node.label }}</span>
                                <span>({{ data.StaffCount }})</span>
                            </span>
                        </el-tree>
                    </el-card>
                </el-aside>
                <div class="shrink-out-view" @click="changeShrink">
                    <div class="shrink-in-view">
                        <i class="el-icon-arrow-right" :class="{ active: !isShrink }"></i>
                    </div>
                </div>
                <el-main class="table-ctn-otd" :width="isShrink ? '0' : '85%'" height="100%" style="padding-top: 0px; padding-bottom: 0px; transition: all 0.3s">
                    <el-card class="box-card" style="padding: 15px; height: 100%; overflow: auto">
                        <div class="flex">
                            <div class="search-name">姓名</div>
                            <el-input class="search-item" size="small" v-model.trim="searchData.name" placeholder="请输入"></el-input>
                            <div class="search-name">账号</div>
                            <el-input class="search-item" size="small" v-model.trim="searchData.account" placeholder="请输入"></el-input>
                            <el-button style="margin-left: 10px;"  size="small" class="search-btn btn-primary" @click="handleSearch()">查询</el-button>
                            <el-button class="search-btn btn-primary"  size="small" @click="reset()">重置</el-button>
                        </div>
                        <el-table
                            :header-cell-style="{ background: '#F2F6FC' }"
                            :data="clientList"
                            border=""
                            style="width: 100%"
                            @selection-change="handlePrintSelectChange"
                        >
                            <el-table-column v-if="permission.printstaffCode" type="selection"></el-table-column>
                            <el-table-column width="80px" prop="JobNum" label="工号" show-overflow-tooltip></el-table-column>
                            <el-table-column width="80px" prop="Name" label="姓名" show-overflow-tooltip></el-table-column>
                            <el-table-column width="80px" prop="Prefix" label="昵称" show-overflow-tooltip></el-table-column>
                            <el-table-column min-width="100px" prop="Account" label="账号" show-overflow-tooltip></el-table-column>
                            <el-table-column min-width="120px" prop="Department" label="部门" show-overflow-tooltip></el-table-column>
                            <el-table-column min-width="100px" prop="Position" label="职位" show-overflow-tooltip></el-table-column>
                            <el-table-column label="性别" width="50px" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ scope.row.Gender | sexHandle }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="PhoneNum" label="电话号码" min-width="120px" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="Email" min-width="120px" label="邮箱" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="UpdateTime" width="160px" label="更新时间" show-overflow-tooltip></el-table-column>
                            <el-table-column width="80px" label="是否离职" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ scope.row.IsDismiss | booleanHandle }}
                                </template>
                            </el-table-column>
                            <el-table-column width="80px" label="是否禁用" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ scope.row.IsDisable | booleanHandle }}
                                </template>
                            </el-table-column>
                            <el-table-column fixed="right" label="操作" :width="opWidth + 'px'">
                                <template slot-scope="scope">
                                    <div class="ops-ctn-vam">
                                        <el-button
                                            size="mini"
                                            title="账号密码"
                                            icon="el-icon-lock"
                                            v-if="permission.account"
                                            @click="showDialog(1, scope.$index, scope.row)"
                                        ></el-button>
                                        <el-button size="mini" title="分配权限" v-if="permission.authority" @click="showDialog(6, scope.$index, scope.row)">
                                            <i class="fa fa-gears"></i>
                                        </el-button>
                                        <el-button size="mini" title="数据权限" v-if="permission.userDatasAuth" @click="showDialog(7, scope.$index, scope.row)">
                                            <i class="fa fa-chain"></i>
                                        </el-button>
                                        <el-button size="mini" title="仓库权限" v-if="permission.stoAuth" @click="showDialog(8, scope.$index, scope.row)">
                                            <i class="el-icon-office-building"></i>
                                        </el-button>
                                        <el-button size="mini" title="合作项目权限" v-if="permission.coprojectAuth" @click="showCoProDialog(scope.row)">
                                            <i class="fa fa-archive"></i>
                                        </el-button>
                                        <el-button size="mini" title="页面展示" v-if="permission.dataTableSets" @click="showPagesDialog(scope.row)">
                                            <i class="el-icon-c-scale-to-original"></i>
                                        </el-button>
                                        <el-button v-if="scope.row.IsDisable && permission.used" size="mini" title="启用" @click="stopUse(scope.$index, scope.row)">
                                            <i class="fa fa-check-circle-o"></i>
                                        </el-button>
                                        <el-button
                                            v-else-if="!scope.row.IsDisable && permission.disabled"
                                            size="mini"
                                            title="停用"
                                            @click="stopUse(scope.$index, scope.row)"
                                        >
                                            <i class="fa fa-ban"></i>
                                        </el-button>
                                        <el-button title="编辑" size="mini" v-if="permission.edit" @click="showDialog(3, scope.$index, scope.row)">
                                            <i class="el-icon-edit-outline"></i>
                                        </el-button>
                                        <el-button v-if="permission.randprecord" size="mini" title="赏罚明细" @click="showStaffDetailDialog(scope.row)">
                                            <i class="el-icon-medal"></i>
                                        </el-button>
                                        <el-button title="删除" size="mini" type="danger" v-if="permission.del" @click="delAddress(scope.row)">
                                            <i class="el-icon-delete"></i>
                                        </el-button>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination-ctn">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="searchData.page"
                                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                                :page-size="searchData.limit"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="tableDataLength"
                            ></el-pagination>
                        </div>
                        <!-- 弹窗 -->
                        <el-dialog
                            :append-to-body="true"
                            :close-on-click-modal="false"
                            :before-close="clearDialog"
                            :title="dialogTitle"
                            :visible.sync="dialogVisible"
                            custom-class="base-dialog"
                            width="1000px"
                            v-loading="isLoading"
                            v-loading.fullscreen="false"
                        >
                            <div class="dialog-content">
                                <!-- 分配账号 -->
                                <template v-if="dialogType == 1">
                                    <el-form :model="accountFormData" :rules="rules" ref="accountFormData" label-width="110px">
                                        <el-row :gutter="20">
                                            <el-col :span="24">
                                                <div class="grid-content">
                                                    <el-form-item label="账号" prop="Account">
                                                        <el-input v-model="accountFormData.Account" @input="accountChange"></el-input>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                        </el-row>
                                        <el-row :gutter="20" v-if="!accountFormData.IsAdd">
                                            <el-col :span="24">
                                                <div class="grid-content">
                                                    <el-form-item label="更改密码" prop="Pwd">
                                                        <el-switch v-model="showPwd" active-color="#13ce66" inactive-color="#ff4949" @input="pwdChange"></el-switch>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                        </el-row>
                                        <el-row :gutter="20" v-if="showPwd || accountFormData.IsAdd">
                                            <el-col :span="24">
                                                <div class="grid-content">
                                                    <el-form-item label="新密码" prop="Pwd">
                                                        <el-input v-model="accountFormData.Pwd" type="password"  @input="pwdChange"></el-input>
                                                    </el-form-item>
                                                    <el-form-item>
                                                        <password-line :passwordVal="accountFormData.Pwd"  @input="pwdChange"></password-line>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                        </el-row>
                                        <el-row :gutter="20" v-if="showPwd || accountFormData.IsAdd">
                                            <el-col :span="24">
                                                <div class="grid-content">
                                                    <el-form-item label="确认密码" prop="Pwd2">
                                                        <el-input v-model="accountFormData.Pwd2" type="password"  @input="pwdChange"></el-input>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                        </el-row>
                                        <el-row :gutter="20">
                                            <el-col :span="24">
                                                <div class="grid-content">
                                                    <el-form-item label="是否设置管理员" prop="IsAdmin">
                                                        <el-switch v-model="accountFormData.IsAdmin" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </el-form>
                                </template>
                                <!-- 编辑/新增 -->
                                <template v-else-if="dialogType == 3 || dialogType == 4">
                                    <el-form :model="formData" :rules="rules" ref="formData" label-width="100px">
                                        <el-row :gutter="20">
                                            <el-col :span="12">
                                                <div class="grid-content">
                                                    <el-form-item label="工号" prop="JobNum">
                                                        <el-input v-model="formData.JobNum"></el-input>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                            <el-col :span="12">
                                                <div class="grid-content">
                                                    <el-form-item label="性别" prop="Gender">
                                                        <el-radio-group v-model="formData.Gender">
                                                            <el-radio :label="num1">男</el-radio>
                                                            <el-radio :label="num2">女</el-radio>
                                                        </el-radio-group>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                        </el-row>
                                        <el-row :gutter="20">
                                            <el-col :span="12">
                                                <div class="grid-content">
                                                    <el-form-item label="姓名" prop="Name">
                                                        <el-input v-model="formData.Name"></el-input>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="昵称">
                                                    <el-input v-model="formData.Prefix"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row :gutter="20">
                                            <el-col :span="12">
                                                <div class="grid-content">
                                                    <el-form-item label="部门" prop="OrgId">
                                                        <el-cascader
                                                            style="width: 100%"
                                                            v-model="formData.OrgId"
                                                            :options="orgSearchData"
                                                            :props="cascaderProps"
                                                            clearable
                                                        ></el-cascader>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                            <el-col :span="12">
                                                <div class="grid-content">
                                                    <el-form-item label="生日" prop="Birthday">
                                                        <el-date-picker
                                                            value-format="yyyy-MM-dd"
                                                            v-model="formData.Birthday"
                                                            type="date"
                                                            placeholder="选择日期"
                                                        ></el-date-picker>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                        </el-row>
                                        <el-row :gutter="20">
                                            <el-col :span="12">
                                                <div class="grid-content">
                                                    <el-form-item label="职位" prop="Position">
                                                        <el-input v-model="formData.Position"></el-input>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                            <el-col :span="12">
                                                <div class="grid-content">
                                                    <el-form-item label="电话号码" prop="PhoneNum">
                                                        <el-input v-model="formData.PhoneNum"></el-input>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                        </el-row>
                                        <el-row :gutter="20">
                                            <el-col :span="12">
                                                <div class="grid-content">
                                                    <el-form-item label="QQ">
                                                        <el-input v-model="formData.Qq"></el-input>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                            <el-col :span="12">
                                                <div class="grid-content">
                                                    <el-form-item label="微信">
                                                        <el-input v-model="formData.Wechat"></el-input>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                        </el-row>
                                        <el-row :gutter="20">
                                            <el-col :span="12">
                                                <div class="grid-content">
                                                    <el-form-item label="邮箱" prop="Email">
                                                        <el-input v-model="formData.Email"></el-input>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                            <el-col :span="12">
                                                <div class="grid-content">
                                                    <el-form-item label="薪资结构">
                                                        <el-input v-model="formData.Contacts" placeholder="例：奖金 + 提成" max="50"></el-input>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                        </el-row>
                                        <el-row :gutter="20">
                                            <el-col :span="12">
                                                <div class="grid-content">
                                                    <el-form-item label="员工资料">
                                                        <el-upload
                                                            :action="url"
                                                            :headers="headerObj"
                                                            :data="uploadData"
                                                            :on-error="uploadErr"
                                                            accept=".xls, .xlsx, .doc, .docx, .pdf, .txt, .zip, .7z, .rar"
                                                            :show-file-list="false"
                                                            :on-success="uploadSuccess"
                                                            v-loading.fullscreen.lock="isLoading"
                                                            v-if="!formData.Remark"
                                                        >
                                                            <el-button type="text" size="small" icon="el-icon-document">上传资料</el-button>
                                                        </el-upload>
                                                        <el-button type="text" size="medium" v-else @click="downFile(formData.Remark)">{{ formData.Remark }}</el-button>
                                                        <el-button
                                                            type="text"
                                                            size="medium"
                                                            style="color: red"
                                                            v-if="formData.Remark"
                                                            icon="el-icon-delete"
                                                            @click="removeFile()"
                                                        ></el-button>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                            <el-col :span="12">
                                                <div class="grid-content">
                                                    <el-form-item label="薪水">
                                                        <el-input-number v-model="formData.Salary" :min="0"></el-input-number>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                        </el-row>
                                        <el-row :gutter="20">
                                            <el-col :span="12">
                                                <div class="grid-content">
                                                    <div class="grid-content">
                                                        <el-form-item label="是否上级" prop="IsManage">
                                                            <el-radio-group v-model="formData.IsSuperior">
                                                                <el-radio :label="booleanTrue">是</el-radio>
                                                                <el-radio :label="booleanFalse">否</el-radio>
                                                            </el-radio-group>
                                                        </el-form-item>
                                                    </div>
                                                </div>
                                            </el-col>
                                            <el-col :span="12">
                                                <div class="grid-content">
                                                    <el-form-item label="是否离职" prop="IsDismiss">
                                                        <el-radio-group v-model="formData.IsDismiss">
                                                            <el-radio :label="booleanTrue">是</el-radio>
                                                            <el-radio :label="booleanFalse">否</el-radio>
                                                        </el-radio-group>
                                                    </el-form-item>
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </el-form>
                                </template>
                                <!--  分配权限  -->
                                <template v-if="dialogType == 6">
                                    <div class="dialog-loading" v-show="dialogLoadingShow">
                                        <i class="el-icon-loading dialog-loading-icon"></i>
                                    </div>
                                    <div class="permission-ctn">
                                        <div class="permission-tree">
                                            <el-tree
                                                ref="tree"
                                                :check-strictly="true"
                                                :data="treeData"
                                                :props="defaultProps"
                                                :expand-on-click-node="false"
                                                show-checkbox
                                                node-key="Id"
                                                default-expand-all
                                                :default-checked-keys="checkedTree"
                                                @check="handleNodeChecked"
                                            >
                                                <div class="custom-tree-node" slot-scope="{ node, data }">
                                                    <span class="element-name" :class="{ lv3: node.level == 3 }">{{ data.Name }}</span>
                                                    <span class="element-ops">
                                                        <span v-for="item in data.Elements" :key="item.Id">
                                                            <input
                                                                type="checkbox"
                                                                v-bind:value="item.Id"
                                                                v-model="selelementsId"
                                                                @change="checkElem($event, item, node)"
                                                            />
                                                            {{ item.Name }}
                                                        </span>
                                                    </span>
                                                </div>
                                            </el-tree>
                                        </div>
                                    </div>
                                </template>
                                <template v-if="dialogType == 7">
                                    <div class="dialog-loading" v-show="dialogLoadingShow">
                                        <i class="el-icon-loading dialog-loading-icon"></i>
                                    </div>
                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <div class="grid-content">
                                                <el-aside width="100%" height="100%" style="transition: all 0.3s">
                                                    <el-card class="box-card" style="padding: 10px; height: 520px; overflow: auto">
                                                        <el-row>
                                                            <el-col :span="24">
                                                                <el-input size="small" placeholder="输入关键字进行过滤" v-model="filterAuthText"></el-input>
                                                            </el-col>
                                                        </el-row>
                                                        <el-tree
                                                            check-strictly
                                                            highlight-current
                                                            default-expand-all
                                                            :data="staffData"
                                                            ref="treeAuthOrg"
                                                            :filter-node-method="filterAuthNode"
                                                            node-key="Id"
                                                            :props="treeProps"
                                                            @node-click="handleAuthNodeClick"
                                                        >
                                                            <span class="custom-tree-node" slot-scope="{ node, data }">
                                                                <span>{{ node.label }}</span>
                                                                <span>({{ data.StaffCount }})</span>
                                                            </span>
                                                        </el-tree>
                                                    </el-card>
                                                </el-aside>
                                            </div>
                                        </el-col>
                                        <el-col :span="16">
                                            <div class="grid-content table-ctn" style="margin-bottom: 0px">
                                                <el-table
                                                    :header-cell-style="{ background: '#F2F6FC' }"
                                                    :data="staffList"
                                                    border=""
                                                    style="width: 100%"
                                                    height="520px"
                                                    ref="multipleTable"
                                                    @selection-change="handleSelectionChange"
                                                >
                                                    <el-table-column type="selection"></el-table-column>
                                                    <el-table-column width="100px" prop="JobNum" label="工号" show-overflow-tooltip></el-table-column>
                                                    <el-table-column width="80px" prop="Name" label="姓名" show-overflow-tooltip></el-table-column>
                                                    <el-table-column min-width="120px" prop="Department" label="部门" show-overflow-tooltip></el-table-column>
                                                    <el-table-column min-width="100px" prop="Position" label="职位" show-overflow-tooltip></el-table-column>
                                                </el-table>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </template>
                                <template v-if="dialogType == 8">
                                    <div class="dialog-loading" v-show="dialogLoadingShow">
                                        <i class="el-icon-loading dialog-loading-icon"></i>
                                    </div>
                                    <div class="grid-content table-ctn" style="margin-bottom: 0px">
                                        <el-table
                                            :header-cell-style="{ background: '#F2F6FC' }"
                                            :data="tableStoData"
                                            border=""
                                            style="width: 100%"
                                            height="520px"
                                            ref="stoMultiTable"
                                            @selection-change="handleStoSelectionChange"
                                        >
                                            <el-table-column type="selection"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="250px" prop="Name" label="仓库名称"
                                                ><template slot-scope="scope"
                                                    >{{ scope.row.Name }} <span style="color: #8492a6" v-if="scope.row.Type == 1"> (前置仓)</span></template
                                                ></el-table-column
                                            >
                                            <el-table-column show-overflow-tooltip width="200px" prop="Code" label="仓库编号"></el-table-column>
                                            <el-table-column show-overflow-tooltip label="所在省市">
                                                <template slot-scope="scope">{{ scope.row.Province }}{{ scope.row.City }}</template>
                                            </el-table-column>
                                            <el-table-column show-overflow-tooltip prop="Address" label="地址"></el-table-column>
                                            <el-table-column width="100" show-overflow-tooltip label="状态">
                                                <template slot-scope="scope">{{ scope.row.State | stateHandle }}</template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </template>
                                <!-- <template v-if="dialogType == 9">
                                    <div class="dialog-loading" v-show="dialogCoProShow">
                                        <i class="el-icon-loading dialog-loading-icon"></i>
                                    </div>
                                    <div class="grid-content table-ctn" style="margin-bottom: 0px">
                                        <el-table
                                            :header-cell-style="{ background: '#F2F6FC' }"
                                            :data="tableCoProData"
                                            border=""
                                            style="width: 100%"
                                            height="520px"
                                            ref="coProMultiTable"
                                            @selection-change="handleCoProChange"
                                        >
                                            <el-table-column type="selection"></el-table-column>
                                            <el-table-column show-overflow-tooltip width="200px" prop="Name" label="合作项目名称"></el-table-column>
                                        </el-table>
                                    </div>
                                </template> -->
                            </div>
                            <span slot="footer" class="dialog-footer" v-if="dialogType != 6 && dialogType != 7 && dialogType != 8">
                                <el-button @click="clearDialog">取 消</el-button>
                                <el-button class="btn-primary" @click="submitForm">确 定</el-button>
                            </span>
                        </el-dialog>
                    </el-card>
                </el-main>
            </el-container>
        </el-container>
        <!--    奖罚记录清单，针对个人    -->
        <el-dialog :close-on-click-modal="false" title="奖罚记录" :visible.sync="showRAndPDetailDialog" :append-to-body="true" width="1400px">
            <div v-if="showRAndPDetailDialog">
                <rewardAndPRecordDetail :StaffId="staffId" :OrgId="orgId"></rewardAndPRecordDetail>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="dialogTitle" :visible.sync="showTBPagesDialog" :append-to-body="true" width="600px">
            <div v-if="showTBPagesDialog">
                <tablePages :StaffId="staffId" :StaffName="staffName"></tablePages>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="dialogTitle" :visible.sync="dialogCoProShow" :append-to-body="true" width="400px">
            <div v-if="dialogCoProShow" class="table-ctn" style="margin-top: 10px; padding-bottom: 10px">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableCoProData"
                    border=""
                    height="500px"
                    ref="coProMultiTable"
                    @selection-change="handleCoProChange"
                >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Name" label="合作项目名称"></el-table-column>
                </el-table>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="清除登录状态" :visible.sync="clearTokenDialog" :append-to-body="true" width="400px">
            <div v-if="clearTokenDialog" class="ctdialog">
                <el-form :rules="clearTokenrules" label-width="90px">
                    <el-form-item label="所属项目" style="margin-bottom: 0px" prop="Name">
                        <el-select size="small" v-model="clearTokenAppName" placeholder="请选择">
                            <el-option label="一企管PC" value="yqgpc"></el-option>
                            <el-option label="一企管小程序" value="yqgxcx"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="企业员工" style="margin-bottom: 0px" prop="UserId">
                        <el-select size="small" v-model="clearTokenUserId" multiple collapse-tags clearable filterable placeholder="请选择">
                            <el-option v-for="(item, index) in SIdList" :key="index" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="btn-ctn">
                        <el-button size="small" class="search-btn btn-primary" @click="clearToken">确定</el-button>
                        <el-button size="small" class="search-btn" @click="openClearTokenDialog">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import rewardAndPRecordDetail from '@/components/business/msgSetting/rewardAndPRecordDetail';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import passwordLine from '@/components/common/checkPassword';
import tablePages from '@/components/common/tablePages';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        rewardAndPRecordDetail,
        passwordLine,
        tablePages
    },
    data() {
        // let checkPhone = this.$util.checkPhone;
         let checkPhone = this.$util.validatePhoneNumber;
        let checkEmail = this.$util.checkEmail;
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            showRAndPDetailDialog: false,
            showTBPagesDialog: false,
            clearTokenDialog: false,
            clearTokenAppName: '',
            clearTokenUserId: [],
            SIdList: [],
            staffId: '',
            staffName: '',
            orgId: '',
            orgSearchData: [],
            idList: [],
            entpId: userMsg.EntpId,
            staffData: [],
            staffList: [],
            treeProps: {
                children: 'Childrens',
                label: 'Name'
            },
            filterText: '',
            filterAuthText: '',
            cascaderProps: {
                emitPath: false,
                expandTrigger: 'hover',
                children: 'Childrens',
                label: 'Name',
                value: 'Id',
                checkStrictly: true
            },
            //------------------------
            userMsg: userMsg,
            isLoading: false,
            dialogLoadingShow: false,
            dialogCoProShow: false,
            nowStaffMsg: {}, // 当前操作的员工信息
            defaultProps: {
                children: 'Children',
                label: 'Name'
            },
            treeData: [], //模块树数据集
            checkedTree: [], //已选中的树节点
            selelementsId: [], //已选中的按钮
            defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE + '"',
            download_url: this.$util.QN_URL_BASE,
            url: '/api/UploadFile/UploadSingle',
            uploadData: { key: 'StffData', isPrivate: false },
            headerObj: {
                'access-key': userMsg.Token,
                reqApp: 'yqgPC'
            },
            showPwd: false, // 是否分配账号的密码
            CertType: '',
            num1: 1,
            num2: 2,
            booleanTrue: true,
            booleanFalse: false,
            dialogType: 1, // 弹窗类型
            dialogVisible: false,
            dialogTitle: '', //dialog标题
            // 认证
            rZformData: {
                StaffId: '',
                EntpId: userMsg.EntpId,
                CertType: '',
                CertNum: '',
                IssueDate: '',
                ExpirationDate: '',
                Data1: 1,
                Data2: '',
                Data3: '',
                Data4: '',
                CertImgUrl: '',
                ScanImgUrl: '',
                Remark: ''
            },
            // 分配账号
            accountFormData: {
                StaffId: '',
                Account: '',
                IsAdmin: false,
                Pwd: '',
                Pwd2: '',
                IsDel: false,
                IsAdd: true,
                Id: '' // 账号id
            },
            //修改 / 新增
            formData: {
                StaffId: '',
                JobNum: '',
                Name: '',
                Department: '',
                Position: '',
                Birthday: '',
                Gender: 1,
                PhoneNum: '',
                Qq: '',
                Wechat: '',
                Email: '',
                Remark: '',
                IsDismiss: false,
                Contacts: '',
                Prefix: '',
                StartSalary: 0,
                Salary: 0,
                IsSuperior: false,
                OrgId: '',
                FileUrl: ''
            },
            clientList: [],
            rules: {
                Name: [{ required: true, message: '该项必填', trigger: 'blur' }],
                JobNum: [{ required: true, message: '该项必填', trigger: 'blur' }],
                CertType: [{ required: true, message: '该项必填', trigger: 'blur' }],
                OrgId: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Position: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Birthday: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Gender: [{ required: true, message: '该项必填', trigger: 'blur' }],
                PhoneNum: [{ required: true, validator: checkPhone, trigger: 'blur' }],
                Wechat: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Email: [{ required: false, validator: checkEmail, trigger: 'blur' }],
                Remark: [{ required: true, message: '该项必填', trigger: 'blur' }],
                IsDismiss: [{ required: true, message: '该项必填', trigger: 'blur' }],
                AuthType: [{ required: true, message: '该项必填', trigger: 'change' }],
                CertNum: [{ required: true, message: '该项必填', trigger: 'blur' }],
                IssueDate: [{ required: true, message: '该项必填', trigger: 'blur' }],
                ExpirationDate: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Data1: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Data2: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Data3: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Data4: [{ required: true, message: '该项必填', trigger: 'blur' }],
                CertImgUrl: [{ required: true, message: '该项必填', trigger: 'change' }],
                ScanImgUrl: [{ required: true, message: '该项必填', trigger: 'change' }]
            },
            clearTokenrules: {
                Name: [{ required: true, message: '该项必选', trigger: 'blur' }]
            },
            tableDataLength: 0,
            searchData: {
                name:'',
                account:'',
                page: 1, // 当前页数
                limit: 15, // 每页限制条数
                key: '', //关键字查询
                cascadeId: '',
                notLeave: true
            },
            permission: {}, //该页面的权限
            ownHighestLevel: false,
            assignPermissions: [], //待分配或取消分配的模块和权限按钮\数据权限
            oldPermissions: [],
            isShrink: false, // 是否收缩状态
            parentsData: [], // 遍历出的父节点列表
            tableStoData: [], //仓库列表
            tableCoProData: [], //合作项目列表
            opWidth: 20 //操作栏的宽
        };
    },
    filters: {
        sexHandle(value) {
            if (value == 0) {
                return '未知';
            } else if (value == 1) {
                return '男';
            } else {
                return '女';
            }
        },
        stateHandle(value) {
            if (value == 0) {
                return '正常使用';
            } else if (value == 1) {
                return '停用';
            }
        }
    },
    watch: {
        filterText(val) {
            this.$refs.treeOrg.filter(val);
        },
        filterAuthText(val) {
            this.$refs.treeAuthOrg.filter(val);
        }
    },
    created() {
        this.permission = this.$util.getPermission('staffManagement');
        this.getOrgTreeForStaff();
        this.getTableData();
        this.getEntpType();
        this.checkOwnHighestLevel();
        this.getOrgTree();
        this.getSIdList();
        let shrinkStu = this.$util.getLocalStorage('staffShrinkStu');
        this.isShrink = shrinkStu * 1 === 1;

        //根据权限赋值操作栏宽度
        if (this.permission.account) this.opWidth += 42;
        if (this.permission.authority) this.opWidth += 42;
        if (this.permission.userDatasAuth) this.opWidth += 42;
        if (this.permission.stoAuth) this.opWidth += 42;
        if (this.permission.coprojectAuth) this.opWidth += 42;
        if (this.permission.dataTableSets) this.opWidth += 42;
        if (this.permission.used || this.permission.disabled) this.opWidth += 42;
        if (this.permission.edit) this.opWidth += 42;
        if (this.permission.del) this.opWidth += 42;
        if (this.permission.randprecord) this.opWidth += 42;
    },
    mounted() {},
    computed: {},
    methods: {
        // 改变收缩状态
        changeShrink() {
            this.isShrink = !this.isShrink;
            let value = !this.isShrink ? 0 : 1;
            this.$util.setLocalStorage('staffShrinkStu', value);
        },
        onNotLeaveChecked(val) {
            this.searchData.page = 1;
            this.getOrgTreeForStaff();
            this.getTableData();
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.Name.indexOf(value) !== -1;
        },
        getOrgTreeForStaff() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetOrgTreeForStaff',
                    data: {
                        entpId: this.entpId,
                        notLeave: this.searchData.notLeave
                    }
                })
                .then(res => {
                    if (res.data) {
                        this.staffData = res.data;
                    }
                });
        },
        //共三个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、节点对应的 Node、节点组件本身
        handleNodeClick(data, node, VueComponent) {
            this.searchData.page = 1;
            this.searchData.cascadeId = node.data.CascadeId;
            this.getTableData();
        },
        getOrgTree() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetOrgTree'
                })
                .then(res => {
                    if (res.data) {
                        this.orgSearchData = this.getOrgSearchData(res.data);
                    }
                });
        },
        //递归获取组织数据，为了处理子级为空时，级联选择器出错的问题 edit by qdl 2020/7/17
        getOrgSearchData(data) {
            for (var i = 0; i < data.length; i++) {
                if (!data[i].Childrens || data[i].Childrens.length < 1) {
                    // children若为空数组，则将children设为undefined
                    data[i].Childrens = undefined;
                } else {
                    // children若不为空数组，则继续 递归调用 本方法
                    this.getOrgSearchData(data[i].Childrens);
                }
            }
            return data;
        },

        //---------------------------------------------------------
        // 勾选模块
        handleNodeChecked(data, node) {
            this.assignPermissions = [];
            this.parentsData = [];
            let parentNode = this.$refs.tree.getNode(data.Id);
            if (parentNode) {
                this.getParentsNames(parentNode, []);
            }
            let _checkedTree = this.$refs.tree.getCheckedKeys();
            let flag = false;
            for (let i = 0; i < _checkedTree.length; i++) {
                if (_checkedTree[i] == data.Id) {
                    flag = true;
                    break;
                }
            }
            if (flag) {
                this.checkTreeNoHttp(data, true);
                this.parentsData.forEach(item => {
                    if (this.assignPermissions.findIndex(i => item.key === i.secId) === -1) {
                        this.$refs.tree.setChecked(item.key, true, false);
                        this.assignPermissions.push({ key: 'UserModule', secId: item.key });
                    }
                });
                this.AssignPermission();
            } else {
                this.checkTreeNoHttp(data, false);
                this.UnAssignPermission();
            }
        },
        checkTreeNoHttp(node, checked) {
            this.$refs.tree.setChecked(node.Id, checked, 'deep');
            this.assignPermissions.push({ key: 'UserModule', secId: node.Id });
            let that = this;
            //设置菜单下按钮是否选中
            node.Elements.forEach((x, index) => {
                that.assignPermissions.push({ key: 'UserElement', secId: x.Id });
                if (checked && that.selelementsId.indexOf(x.Id) == -1) {
                    that.selelementsId.push(x.Id);
                } else {
                    for (let i = 0; i < that.selelementsId.length; i++) {
                        if (that.selelementsId[i] == x.Id) {
                            that.selelementsId.splice(i, 1);
                            return true;
                        }
                    }
                }
            });
            //循环节点子级
            for (let i = 0; i < node.Children.length; i++) {
                that.$refs.tree.setChecked(node.Children[i].Id, checked, 'deep');
                that.assignPermissions.push({
                    key: 'UserModule',
                    secId: node.Children[i].Id
                });
                //设置菜单下按钮是否选中
                node.Children[i].Elements.forEach((x, index) => {
                    that.assignPermissions.push({ key: 'UserElement', secId: x.Id });
                    if (checked && that.selelementsId.indexOf(x.Id) == -1) {
                        that.selelementsId.push(x.Id);
                    } else {
                        for (let i = 0; i < that.selelementsId.length; i++) {
                            if (that.selelementsId[i] == x.Id) {
                                that.selelementsId.splice(i, 1);
                                return true;
                            }
                        }
                    }
                });
                //递归
                if (node.Children[i].Children[0]) {
                    that.checkTreeNoHttp(node.Children[i], checked);
                }
            }
        },
        //勾选权限操作按钮
        checkElem(event, data, node) {
            this.parentsData = [];
            this.getParentsNames(node, []);
            this.assignPermissions = [];
            this.assignPermissions.push({ key: 'UserElement', secId: data.Id });
            if (event.target.checked) {
                if (this.selelementsId.indexOf(data.Id) == -1) {
                    this.selelementsId.push(data.Id);
                }

                this.parentsData.forEach(item => {
                    if (this.assignPermissions.findIndex(i => item.key === i.secId) === -1) {
                        this.$refs.tree.setChecked(item.key, true, false);
                        this.assignPermissions.push({ key: 'UserModule', secId: item.key });
                    }
                });

                this.AssignPermission();
            } else {
                let i = this.selelementsId.findIndex(item => {
                    if (item == data.Id) {
                        return true;
                    }
                });
                if (i > -1) {
                    this.selelementsId.splice(i, 1);
                }
                this.UnAssignPermission();
            }
        },
        // 递归获取未选中父级列表
        getParentsNames(obj, result) {
            if (obj.key) {
                if (!obj.checked) {
                    result.push({
                        key: obj.key,
                        label: obj.label
                    });
                }
                this.getParentsNames(obj.parent, result);
            } else {
                this.parentsData = result;
            }
        },
        //分配权限
        AssignPermission() {
            this.dialogLoadingShow = true;
            this.$util
                .axiosPost({
                    url: '/api/Permission/AssignPermission',
                    data: {
                        firstId: this.nowStaffMsg.AccountId ? this.nowStaffMsg.AccountId : this.staffId,
                        permission: this.assignPermissions
                    }
                })
                .then(res => {
                    this.dialogLoadingShow = false;
                    this.$util.successMsg('分配权限成功');
                    this.assignPermissions = [];
                })
                .catch(() => {
                    this.dialogLoadingShow = false;
                    this.assignPermissions = [];
                });
        },
        // 取消权限分配
        UnAssignPermission() {
            this.dialogLoadingShow = true;
            this.$util
                .axiosPost({
                    url: '/api/Permission/UnAssignPermission',
                    data: {
                        firstId: this.nowStaffMsg.AccountId ? this.nowStaffMsg.AccountId : this.staffId,
                        permission: this.assignPermissions
                    }
                })
                .then(res => {
                    this.dialogLoadingShow = false;
                    this.$util.successMsg('取消权限成功');
                    this.assignPermissions = [];
                })
                .catch(() => {
                    this.dialogLoadingShow = false;
                    this.assignPermissions = [];
                });
        },
        // 获取模块树接口
        getPermission() {
            this.$util
                .axiosGet({
                    url: '/api/Permission/GetEntpModulesTree'
                })
                .then(res => {
                    let data = res.data;
                    this.treeData = data;
                });
        },
        // 弹窗关闭前清空验证
        clearDialog() {
            if (this.$refs.accountFormData) {
                this.showPwd = false;
            }
            if (this.$refs.rZformData) {
                this.$util.clearValidate(this, 'rZformData');
            }
            if (this.$refs.formData) {
                this.$util.clearValidate(this, 'formData');
            }
            if (this.$refs.tree) {
                this.$refs.tree.setCheckedKeys([]);
            }
            this.checkedTree = [];
            this.selelementsId = [];
            this.nowStaffMsg = {};
            this.dialogVisible = false;
        },
        // 配置类型列表
        getEntpType() {
            this.$util.getConfigData(`CertType`).then(res => {
                let _CertType = [];
                for (let i = 0; i < res.length; i++) {
                    if (res[i].TypeCode == 'CertType') {
                        _CertType.push(res[i]);
                    }
                }
                this.CertType = _CertType;
            });
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetStaffList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.clientList = data;
                    this.tableDataLength = res.count;
                });
        },
        handleSearch(){
            this.searchData.page = 1;
            this.getTableData();
        },
        reset(){
            this.searchData.page = 1;
            this.searchData.limit = 15;
            this.searchData.name = '';
            this.searchData.account = '';

        },
        // 停用账号
        stopUse(index, data) {
            let that = this;
            this.$util.elConfirm({
                content: data.IsDisable ? '确定启用此账号' : '确定停用此账号',
                confirmMsg: data.IsDisable ? '启用成功' : '停用成功',
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpInfoManagement/ChangeStaffState',
                            data: {
                                StaffId: data.StaffId,
                                isDisable: !data.IsDisable
                            }
                        })
                        .then(res => {
                            that.getTableData();
                        });
                }
            });
        },
        // 显示dialog
        showDialog(type, index, data) {
            if (data) {
                this.nowStaffMsg = data;
            }
            if (type == 1) {
                this.dialogTitle = '为【' + data.Name + '】分配账号';
                this.accountFormData.StaffId = data.StaffId;
                this.$util
                    .axiosGet({
                        url: '/api/EntpInfoManagement/GetStaffAccount',
                        data: { StaffId: data.StaffId }
                    })
                    .then(res => {
                        let resData = res.data;
                        if (data.Account) {
                            this.accountFormData = resData;
                            this.accountFormData.IsAdd = false;
                            this.accountFormData.Id = resData.AccountId;
                        } else {
                            this.accountFormData = {
                                StaffId: data.StaffId,
                                Account: '',
                                IsAdmin: false,
                                Pwd: '',
                                Pwd2: '',
                                IsDel: false,
                                IsAdd: true,
                                Id: '' // 账号id
                            };
                        }
                    });
            } else if (type == 2) {
                this.rZformData.StaffId = data.StaffId;
                this.dialogTitle = '认证';
                this.$util
                    .axiosGet({
                        url: '/api/EntpInfoManagement/StaffAuthInfo',
                        data: { StaffId: data.StaffId }
                    })
                    .then(res => {
                        if (res.data.IsCertifications) {
                            this.dialogType = 5;
                            this.rZformData = res.data;
                        } else {
                            this.rZformData = {
                                StaffId: data.StaffId,
                                EntpId: this.userMsg.EntpId,
                                operator: this.userMsg.EmployeeId,
                                CertType: '',
                                CertNum: '',
                                IssueDate: '',
                                ExpirationDate: '',
                                Data1: 1,
                                Data2: '',
                                Data3: '',
                                Data4: '',
                                CertImgUrl: '',
                                ScanImgUrl: ''
                            };
                        }
                    });
            } else if (type == 3) {
                this.formData = { ...this.clientList[index] };
                this.formData.operator = this.userMsg.EmployeeId;
                this.formData.ownHighestLevel = this.ownHighestLevel;
                this.dialogTitle = '编辑';
            } else if (type == 4) {
                let userMsg = this.userMsg;
                if (!this.ownHighestLevel) {
                    this.$util
                        .axiosGet({
                            url: '/api/EntpInfoManagement/CheckIsLimiteds'
                        })
                        .then(res => {
                            if (res.data) {
                                this.$util.warningMsg('员工人数已达上限');
                                return false;
                            } else {
                                this.dialogType = type;
                                this.dialogVisible = true;
                            }
                        });
                } else {
                    this.dialogType = type;
                    this.dialogVisible = true;
                }
                this.dialogTitle = '新增';
                this.formData = {
                    StaffId: '',
                    JobNum: '',
                    Name: '',
                    Department: '',
                    Position: '',
                    Birthday: '',
                    Gender: 1,
                    PhoneNum: '',
                    Qq: '',
                    Wechat: '',
                    Email: '',
                    Remark: '',
                    IsDismiss: false,
                    Contacts: '',
                    Prefix: '',
                    StartSalary: 0,
                    Salary: 0,
                    ownHighestLevel: this.ownHighestLevel,
                    IsSuperior: false,
                    OrgId: ''
                };

                return false;
            } else if (type == 6) {
                if (!this.nowStaffMsg.AccountId) {
                    this.$util.warningMsg('请先为该员工分配账号');
                    return;
                }
                this.checkedTree = [];
                this.dialogTitle = '为【' + this.nowStaffMsg.Name + ' 】' + '分配权限';
                this.dialogLoadingShow = true;
                this.$util
                    .axiosGet({
                        url: '/api/Permission/GetCheckedModulesIds',
                        data: {
                            staffsAccountId: data.AccountId
                        }
                    })
                    .then(res => {
                        this.checkedTree = res.data.selmodulesId;
                        this.selelementsId = res.data.selelementsId;

                        if (!this.treeData || this.treeData.length == 0) {
                            this.getPermission();
                        }
                        this.dialogLoadingShow = false;
                    });
            } else if (type == 7) {
                this.dialogTitle = '为【' + this.nowStaffMsg.Name + ' 】' + '分配其他人员的数据权限';
                this.dialogLoadingShow = true;
                this.getStaffsTableData();
            } else if (type == 8) {
                this.dialogTitle = '为【' + this.nowStaffMsg.Name + ' 】' + '分配对应仓库数据权限';
                this.dialogLoadingShow = true;
                this.getStoTableData();
            }
            this.dialogType = type;
            this.dialogVisible = true;
        },
        showPagesDialog(row) {
            if (row && row.StaffId) {
                this.dialogTitle = '为【' + row.Name + ' 】' + '配置页面展示';
                this.staffId = row.StaffId;
                this.staffName = row.Name;
                this.showTBPagesDialog = true;
            }
        },
        showCoProDialog(row) {
            if (row && row.StaffId) {
                this.dialogTitle = '为【' + row.Name + ' 】' + '分配合作项目数据权限';
                this.staffId = row.StaffId;
                this.staffName = row.Name;
                this.dialogCoProShow = true;
                this.getCoProTableData();
            }
        },
        // 证件图片上传成功
        certImgSuccess(res) {
            this.rZformData.CertImgUrl = res;
        },
        // 扫描件上传成功
        scanImgUrlSuccess(res) {
            this.rZformData.ScanImgUrl = res;
        },
        // 校验工号
        checkJobNum(id) {
            let clientList = this.clientList;
            let target = this.formData.JobNum;
            for (let i = 0; i < clientList.length; i++) {
                if (clientList[i].StaffId != id) {
                    if (clientList[i].JobNum == target) {
                        return false;
                    }
                }
            }
            return true;
        },
        accountChange(val){
            if(val){
                const hasChinese = /[\u4e00-\u9fa5]/.test(val);
                if (hasChinese) {
                    this.$util.warningMsg('输入的内容不能包含中文字符');
                    return false;
                }                
            }
        },
        pwdChange(val){
            if(val){
                const hasChinese = /[\u4e00-\u9fa5]/.test(val);
                if (hasChinese) {
                    this.$util.warningMsg('输入的密码不能包含中文字符');
                    return false;
                }                
            }
        },
        // 提交数据
        submitForm() {
            let type = this.dialogType;
            if (type == 1) {
                // 分配账号
                if (!this.accountFormData.Account) {
                    this.$util.warningMsg('请输入账号！');
                    return;
                }
                const hasChinese = /[\u4e00-\u9fa5]/.test(this.accountFormData.Account);
                if (hasChinese) {
                    this.$util.warningMsg('输入的内容不能包含中文字符');
                    return false;
                }   
                if ((this.showPwd || this.accountFormData.IsAdd) && !this.accountFormData.Pwd) {
                    this.$util.warningMsg('请输入密码！');
                    return;
                }
                if ((this.showPwd || this.accountFormData.IsAdd) && this.accountFormData.Pwd.length < 6) {
                    this.$util.warningMsg('密码长度不能小于6位');
                    return;
                }
                if (this.accountFormData.Pwd == '123456' || this.accountFormData.Pwd == '654321' || this.accountFormData.Pwd == '111111') {
                    this.$util.warningMsg('请勿使用过于简单的密码');
                    return;
                }
                if ((this.showPwd || this.accountFormData.IsAdd) && this.accountFormData.Pwd != this.accountFormData.Pwd2) {
                    this.$util.warningMsg('两次输入的密码不一致！');
                    return;
                }
                const hasChinese_pwd = /[\u4e00-\u9fa5]/.test(this.accountFormData.Pwd);
                if (hasChinese_pwd) {
                    this.$util.warningMsg('输入的密码不能包含中文字符');
                    return false;
                }  
                let url = '/api/EntpInfoManagement/EditStaffAccount';
                this.$refs.accountFormData.validate(valid => {
                    if (valid) {
                        this.$util
                            .axiosPost({
                                url: url,
                                data: this.accountFormData
                            })
                            .then(() => {
                                this.$util.successMsg('操作成功');
                                this.dialogVisible = false;
                                this.getTableData();
                                this.accountFormData = {
                                    StaffId: '',
                                    Account: '',
                                    IsAdmin: false,
                                    Pwd: '',
                                    Pwd2: '',
                                    IsDel: false
                                };
                                this.showPwd = false;
                            });
                    } else {
                        this.$util.errorMsg('操作失败');
                        return false;
                    }
                });
            } else if (type == 2) {
                // 员工认证
                this.$refs.rZformData.validate(valid => {
                    if (valid) {
                        this.$util
                            .axiosPost({
                                url: '/api/EntpInfoManagement/AddStaffAuth',
                                data: this.rZformData
                            })
                            .then(() => {
                                this.$util.clearValidate(this, 'rZformData');
                                this.$util.successMsg('认证成功');
                                this.dialogVisible = false;
                                this.getTableData();
                                // 认证
                                this.rZformData = {
                                    StaffId: '',
                                    EntpId: this.userMsg.EntpId,
                                    operator: this.userMsg.EmployeeId,
                                    CertType: '',
                                    CertNum: '',
                                    IssueDate: '',
                                    ExpirationDate: '',
                                    Data1: 1,
                                    Data2: '',
                                    Data3: '',
                                    Data4: '',
                                    CertImgUrl: '',
                                    ScanImgUrl: '',
                                    Remark: ''
                                };
                            });
                    } else {
                        return false;
                    }
                });
            } else if (type == 3) {
                // edit员工
                if (!this.checkJobNum(this.formData.StaffId)) {
                    this.$util.warningMsg('员工工号已存在');
                    return;
                }
                this.$refs.formData.validate(valid => {
                    if (valid) {
                        this.isLoading = true;
                        this.$util
                            .axiosPost({
                                url: '/api/EntpInfoManagement/EditStaff',
                                data: this.formData
                            })
                            .then(() => {
                                this.$util.clearValidate(this, 'formData');
                                this.$util.successMsg('操作成功');
                                this.dialogVisible = false;
                                this.getTableData();
                                this.isLoading = false;

                                this.$util.clearLocalStorage('sIdList');
                            })
                            .catch(() => {
                                this.isLoading = false;
                            });
                    } else {
                        return false;
                    }
                });
            } else if (type == 4) {
                // add员工
                if (!this.checkJobNum('')) {
                    this.$util.warningMsg('员工工号已存在');
                    return;
                }
                this.$refs.formData.validate(valid => {
                    if (valid) {
                        this.isLoading = true;
                        this.$util
                            .axiosPost({
                                url: '/api/EntpInfoManagement/EditStaff',
                                data: this.formData
                            })
                            .then(() => {
                                this.$util.clearValidate(this, 'formData');
                                this.$util.successMsg('操作成功');
                                this.dialogVisible = false;
                                this.isLoading = false;
                                this.getTableData();

                                this.$util.clearLocalStorage('sIdList');
                            })
                            .catch(() => {
                                this.isLoading = false;
                            });
                    } else {
                        return false;
                    }
                });
            } else if (type == 6) {
                // 分配权限
                this.dialogVisible = false;
                this.checkedTree = [];
                this.nowStaffMsg = {};
            } else if (type == 7) {
                // 分配数据权限
                this.dialogVisible = false;
                this.staffList = [];
                this.nowStaffMsg = {};
            }
        },
        // 删除员工
        delAddress(data) {
            let that = this;
            this.$util.elConfirm({
                content: '是否删除该员工信息?',
                confirm() {
                    that.$util
                        .axiosGet({
                            url: '/api/EntpInfoManagement/DeleteStaff',
                            data: {
                                StaffId: data.StaffId
                            }
                        })
                        .then(() => {
                            that.getTableData();
                            this.$util.clearLocalStorage('sIdList');
                        });
                }
            });
        },
        //判断是否拥有最高级别套餐
        checkOwnHighestLevel() {
            this.$util
                .axiosGet({
                    url: '/api/SoftwareSets/CheckOwnHighestLevel',
                    data: {
                        entpId: this.userMsg.EntpId
                    }
                })
                .then(res => {
                    this.ownHighestLevel = res.data;
                });
        },
        //判断添加员工是否达到上限
        checkIsLimiteds() {
            let result = true;
            let userMsg = this.userMsg;
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/CheckIsLimiteds'
                })
                .then(res => {
                    result = res.errcode == 0;
                });
            return result;
        },
        // 分页处理
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        onEditorChange({ quill, html, text }) {
            this.content = html;
        },
        downFile(url) {
            if (url) {
                let a = document.createElement('a');
                a.href = this.download_url + this.formData.FileUrl; // 这里的请求方式为get，如果需要认证，接口上需要带上token
                a.target = '_blank';
                a.click();
            }
        },
        removeFile() {
            let that = this;
            that.formData.Remark = '';
        },
        beforeUpload(file) {
            this.loading = true;
        },
        uploadSuccess(res) {
            let that = this;
            if (res.errcode == 0) {
                that.formData.Remark = res.fileName + '.' + res.fileExt;
                that.formData.FileUrl = res.fileUrl;
            } else {
                this.$util.errorMsg(res.errmsg);
            }
            this.loading = false;
        },
        uploadErr(error) {
            this.loading = false;
            const result = JSON.parse(error.message);
            this.$util.errorMsg(result.message);
        },
        gotoStaffRecord() {
            this.$router.push(`/msgSetting/rAndPRecords`);
        },
        showStaffDetailDialog(item) {
            this.staffId = item.StaffId;
            this.orgId = item.OrgId;
            this.showRAndPDetailDialog = true;
        },
        getStaffsTableData(cascadeId) {
            let accountId = this.nowStaffMsg.AccountId;
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetAuthStaffList',
                    data: { cascadeId: cascadeId, sId: accountId }
                })
                .then(res => {
                    let data = res.data;
                    this.staffList = data;
                    this.oldPermissions = [];
                    this.$nextTick(() => {
                        this.staffList.forEach(row => {
                            if (row.IsPermission) {
                                this.oldPermissions.push({
                                    key: 'UserRUsers',
                                    secId: row.StaffId
                                });
                                this.$refs.multipleTable.toggleRowSelection(row, true);
                            }
                        });
                    });
                });
            this.dialogLoadingShow = false;
        },
        handleSelectionChange(val) {
            let oldPermission = this.oldPermissions;
            this.oldPermissions = [];
            this.assignPermissions = [];
            for (let i = 0; i < val.length; i++) {
                this.oldPermissions.push({
                    key: 'UserRUsers',
                    secId: val[i].StaffId
                });
            }
            if (oldPermission.length > val.length) {
                //去掉权限
                val.forEach((v, i) => {
                    oldPermission.forEach((item, index) => {
                        if (v.AccountId == item.secId) {
                            oldPermission.splice(index, 1);
                        }
                    });
                });

                this.assignPermissions = oldPermission;
                this.UnAssignPermission();
            } else if (oldPermission.length < val.length) {
                if (val.length > 0) {
                    //加权限
                    oldPermission.forEach((item, index) => {
                        for (let i = 0; i < val.length; i++) {
                            if (val[i].AccountId == item.secId) {
                                val.splice(i, 1);
                            }
                        }
                    });

                    for (let i = 0; i < val.length; i++) {
                        this.assignPermissions.push({
                            key: 'UserRUsers',
                            secId: val[i].AccountId
                        });
                    }
                    this.AssignPermission();
                }
            }
            this.$util.clearLocalStorage('authSIdList');
        },
        handleAuthNodeClick(data, node, VueComponent) {
            this.getStaffsTableData(node.data.CascadeId, this.nowStaffMsg.AccountId);
        },
        filterAuthNode(value, data) {
            if (!value) return true;
            return data.Name.indexOf(value) !== -1;
        },
        handlePrintSelectChange(val) {
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].StaffId);
            }
            this.idList = idList;
        },
        // 打印
        printLabels() {
            if (this.idList.length < 1) {
                this.$util.warningMsg('请选择员工进行打印');
                return;
            } else {
                //传到接口调用打印出来
                this.$util
                    .axiosPost({
                        url: '/api/EntpGoodsLabels/PrintStaffLabels',
                        data: {
                            Ids: this.idList
                        }
                    })
                    .then(() => {});
            }
        },
        //获取仓库数据
        getStoTableData() {
            let accountId = this.nowStaffMsg.AccountId;
            this.$util
                .axiosGet({
                    url: '/api/EntpWarehouse/GetEntpWarehouseAuthList',
                    data: { sId: accountId },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableStoData = data;
                    this.oldPermissions = [];
                    this.$nextTick(() => {
                        this.tableStoData.forEach(row => {
                            if (row.IsPermission) {
                                this.oldPermissions.push({
                                    key: 'UserRWarehouses',
                                    secId: row.WarehouseId
                                });
                                this.$refs.stoMultiTable.toggleRowSelection(row, true);
                            }
                        });
                    });
                })
                .catch(() => {})
                .finally(() => {
                    this.dialogLoadingShow = false;
                });
        },
        handleStoSelectionChange(val) {
            let oldPermission = this.oldPermissions;
            this.oldPermissions = [];
            this.assignPermissions = [];
            for (let i = 0; i < val.length; i++) {
                this.oldPermissions.push({
                    key: 'UserRWarehouses',
                    secId: val[i].WarehouseId
                });
            }
            if (oldPermission.length > val.length) {
                //去掉权限
                val.forEach((v, i) => {
                    oldPermission.forEach((item, index) => {
                        if (v.WarehouseId == item.secId) {
                            oldPermission.splice(index, 1);
                        }
                    });
                });

                this.assignPermissions = oldPermission;
                this.UnAssignPermission();
            } else if (oldPermission.length < val.length) {
                if (val.length > 0) {
                    //加权限
                    oldPermission.forEach((item, index) => {
                        for (let i = 0; i < val.length; i++) {
                            if (val[i].WarehouseId == item.secId) {
                                val.splice(i, 1);
                            }
                        }
                    });

                    for (let i = 0; i < val.length; i++) {
                        this.assignPermissions.push({
                            key: 'UserRWarehouses',
                            secId: val[i].WarehouseId
                        });
                    }
                    this.AssignPermission();
                }
            }
        },
        //获取仓库数据
        getCoProTableData() {
            let accountId = this.staffId;
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetCoProjectAuthList',
                    data: { sId: accountId },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableCoProData = data;
                    this.oldPermissions = [];
                    this.$nextTick(() => {
                        this.tableCoProData.forEach(row => {
                            if (row.IsPermission) {
                                this.oldPermissions.push({
                                    key: 'UserRCoProjects',
                                    secId: row.ProjectId
                                });
                                this.$refs.coProMultiTable.toggleRowSelection(row, true);
                            }
                        });
                    });
                })
                .catch(() => {})
                .finally(() => {});
        },
        handleCoProChange(val) {
            let oldPermission = this.oldPermissions;
            this.oldPermissions = [];
            this.assignPermissions = [];
            for (let i = 0; i < val.length; i++) {
                this.oldPermissions.push({
                    key: 'UserRCoProjects',
                    secId: val[i].ProjectId
                });
            }
            if (oldPermission.length > val.length) {
                //去掉权限
                val.forEach((v, i) => {
                    oldPermission.forEach((item, index) => {
                        if (v.ProjectId == item.secId) {
                            oldPermission.splice(index, 1);
                        }
                    });
                });

                this.assignPermissions = oldPermission;
                this.UnAssignPermission();
            } else if (oldPermission.length < val.length) {
                if (val.length > 0) {
                    //加权限
                    oldPermission.forEach((item, index) => {
                        for (let i = 0; i < val.length; i++) {
                            if (val[i].ProjectId == item.secId) {
                                val.splice(i, 1);
                            }
                        }
                    });

                    for (let i = 0; i < val.length; i++) {
                        this.assignPermissions.push({
                            key: 'UserRCoProjects',
                            secId: val[i].ProjectId
                        });
                    }
                    this.AssignPermission();
                }
            }
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        openClearTokenDialog() {
            this.clearTokenDialog = !this.clearTokenDialog;
            this.clearTokenAppName = '';
            this.clearTokenUserId = [];
        },
        clearToken() {
            var that = this;
            if (!that.clearTokenAppName) {
                that.$util.errorMsg('请选择应用名称');
                return false;
            }
            that.$confirm(that.clearTokenUserId.length === 0 ? '是否清除所有员工的登录状态' : '是否清除选中员工登录状态?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: false
            })
                .then(() => {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpInfoManagement/ClearUserToken',
                            data: {
                                AppName: that.clearTokenAppName,
                                Ids: that.clearTokenUserId
                            }
                        })
                        .then(res => {
                            if (res.errcode === 0) {
                                that.$util.successMsg(res.errmsg);
                                that.clearTokenDialog = false;
                            } else that.$util.errorMsg(res.errmsg);
                        });
                })
                .catch(() => {});
        }
    }
};
</script>
<style lang="less" scoped>
.ops-ctn-vam {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.dialog-loading {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
}
.dialog-loading-icon {
    position: absolute;
    left: 46%;
    top: 43%;
    transform: translate(-50%, -50%);
    font-size: 50px;
    color: @theme;
}
.permission-ctn {
    display: flex;
}
.dialog-content {
    overflow-x: auto;
    position: relative;
    overflow: auto;
}
.root-checkbox {
    width: 14px;
    height: 14px;
    background: white;
}
.root-checkbox-ctn {
    display: flex;
    align-items: center;
}
.permission-tree {
    // width: 100%;
    // overflow-y: scroll;会影响x轴滚动条的展现
    height: 460px;
    padding-bottom: 50px;
}
.lv3 {
    width: 132px !important;
}
.shrink-out-view {
    background-color: rgba(0, 0, 0, 0.075);
    display: flex;
    align-items: center;
    cursor: pointer;
}
.shrink-in-view {
    width: 100%;
    height: 30px;
    background-color: #409eff;
    border-radius: 7px;
    text-align: center;
    display: flex;
    align-items: center;
    color: #fff;
}
.shrink-in-view .active {
    transform: rotate(-180deg);
}
.btn-warning {
    background-color: rgb(230, 162, 60);
    color: white;
}
.ctdialog {
    height: 140px;
    padding: 10px;
}
.btn-ctn {
    float: right;
}
.search-item{
    width: 150px;
}
.search-btn{
    height: 32px;
}
</style>
<style lang="less">
.element-name {
    display: inline-block;
    width: 150px;
}
.el-tree-node {
    position: relative;
}
.business-content-main .el-card::-webkit-scrollbar {
    display: none;
}
</style>
